import { useState } from 'react';
import { useInterval } from '../shared';
import { Stack } from '@mui/material';
import { WarningIcon } from '@phosphor-icons/react';
import * as React from 'react';

export const BlinkingWarningIcon = ({size = 24}: {size?: number}) => {
  const [iconVisible, setIconVisible] = useState(true);

  useInterval(() => {
    setIconVisible(prev => !prev);
  }, 1000);

  return <Stack sx={{position: 'relative'}}>
    <WarningIcon size={size} color="#DE3124"
                 style={{
                   opacity: iconVisible ? 1 : 0,
                   transition: 'opacity 0.3s ease-in-out'
                 }}
                 weight={'regular'} />
    <WarningIcon size={size} color="#DE3124"
                 style={{
                   position: 'absolute',
                   zIndex: 1,
                   width: size,
                   height: size,
                   left: 0,
                   opacity: iconVisible ? 0 : 1,
                   transition: 'opacity 0.3s ease-in-out'
                 }}
                 weight={'fill'} />
  </Stack>
}
